module.exports = __webpack_public_path__ + "img/classification-active.92bad031.svg";